import React from 'react'
import { Helmet } from 'react-helmet-async';
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumbGartner from '../components/BreadcrumbGartner'
import GartnerComponent from '../components/GartnerComponent'
import GartnerSection from '../components/GartnerSection'

export default function GartnerMarketingSymposiumXpo2025() {
  return (
    <div>
      <Helmet>
                <title>ProPlus Data at Gartner Event 2025 | B2B Data Innovation</title>
                <meta name="description" content="Explore how ProPlus Data showcased its B2B data intelligence & innovation at the Gartner Event 2025. Discover event highlights, insights, & key takeaways."/>
                <meta name="keywords" content="ProPlus Data, Forrester B2B Summit 2025, B2B Marketing, Data Intelligence, Customer Insights, Marketing Technology, Sales Optimization, GTM Strategies, Business Impact, Personalization, Denver Summit, Intelligent Data Solutions"/>
                <link rel="canonical" href="https://proplusdata.co/gartner-event"/>
                <meta property="og:url" content="https://proplusdata.co/gartner-event" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="ProPlus Data at Gartner Event 2025 | B2B Data Innovation" />
                <meta property="og:description"
                      content="Discover how ProPlus Data demonstrated B2B data innovation and insights at the Gartner Event 2025. View highlights and expert takeaways." />
            </Helmet>
      <Header1/>
      <BreadcrumbGartner/>
      <GartnerComponent/>
      <GartnerSection/>
      <Footer/>
    </div>
  )
}
